/**
 *  Filename ....: addpoitem.component.ts
 *  Created by ..: ianday
 *  on Date .....: 5/24/23
 **/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {MedicationService} from '../../../../services/medication.service';
import {MatTableDataSource} from '@angular/material/table';
import {SupplierItems} from '../../../../models/supplieritems';
import {DwUtils} from '../../../../components/utils/dw-utils';
import {Settings} from '../../../../services/settings';
import {map, startWith} from 'rxjs/operators';
import {PurchaseOrderItems} from '../../../../models/purchaseorderitems';
import { SupplierMedication } from '../../../../models/supplier-medication';
import {TransactionHistoryService} from '../../../../services/transactionhistory.service';
import {MaterialService} from '../../../../services/material.service';

@Component({
    selector: 'app-addmedpoitem',
    templateUrl: './addmedpoitem.component.html',
    styleUrls: ['./addmedpoitem.component.css']
})

export class AddMedPOItemComponent implements OnInit {

    public filteredMFOptions: Observable<string[]>;
    public _supplierId: number;
    public itemFamilyList: any;                      // used in the autocomplete filter
    public records: Array<SupplierItems>;
    public refList: Array<PurchaseOrderItems>;

    public unitPrice: number;
    public costBase: number;
    public costPerDose: number;
    public leadTimeDays: number;

    public addEditFlag = true;
    public strErr = '';

    public ndcDescription: string | null = '';
    public selectedItemFamily: SupplierItems = new SupplierItems();
    public mfControl = new FormControl('');
    public medService: MedicationService;
    public matService: MaterialService;
    public txService: TransactionHistoryService;
    public dataSource: MatTableDataSource<SupplierItems>;

    @Output() submitAddPOItemEvent = new EventEmitter<SupplierItems>();
    @Output() cancelAddPOItemEvent = new EventEmitter();

    private _mfFilter(value: string): string[] {
        const filterValue = value.toLowerCase();
        const strRet = this.itemFamilyList.filter(option => option.toLowerCase().includes(filterValue));
        return strRet;
    }

    @Input() set supplierId(val: number) {
        this._supplierId = val;
    }
    get supplierId(): number {
        return this._supplierId;
    }

    constructor(medSvc: MedicationService, matSvc: MaterialService, txService: TransactionHistoryService) {
        this.medService = medSvc;
        this.matService = matSvc;
        this.txService = txService;
    }

    ngOnInit() {

    }
    public clearForm(): void {
        this.selectedItemFamily = new SupplierItems();
        this.ndcDescription = '';
        this.mfControl.setValue('');
        this.strErr = '';
        this.costPerDose = 0;
    }
    createRefHistItems(sm: SupplierItems): void  {
        this.costBase = sm.costBase;
        this.unitPrice = sm.unitPrice;
        this.leadTimeDays = sm.leadTimeDays;
    }
    /*** entry point ***/
    public doInitialize(sVal: SupplierItems, aeFlag: boolean, recs: any): void {

        this.addEditFlag = aeFlag;
        this.selectedItemFamily = sVal;
        this.createRefHistItems(sVal);
        this.refList = recs;
        this.strErr = '';

        if (this.addEditFlag === true) {
            this.clearForm();
        }
        else {
            this.mfControl.setValue(this.fmtMedicationString(this.selectedItemFamily.origNdcNumber,
                this.selectedItemFamily.description));
            this.costPerDose = this.calcCostPerDose(this.selectedItemFamily.unitPrice, this.selectedItemFamily.packageSize)
            this.ndcDescription = this.mfControl.value;
        }

        this.medService.getSupplierMedicationsBySupplierIdShort(this.supplierId).subscribe(
            (data) => {
                this.itemFamilyList = new Array();
                this.records = new Array<SupplierItems>();

                for (const item of data) {
                    const sm = new SupplierItems();
                    sm.setFamilyMeds(item, this.supplierId);
                    this.itemFamilyList.push(this.fmtMedicationString(sm.origNdcNumber, sm.description));
                    this.records.push(sm);
                }

                this.filteredMFOptions = this.mfControl.valueChanges.pipe(
                    startWith(''),
                    map(value => this._mfFilter(value || '')),
                );
            },
            (error) => {
                Settings.getInstance().handleError(error, 'fetching medications for suppliers');
        });
    }
    public fmtMedicationString(ndc: string, desc: string): string {
        return ndc + ': ' + desc;
    }
    public medFamilySelectVal(val: any): void {
        const selectedVal = this.mfControl.value;
        const selectedItemPref = selectedVal.split(':')[0];

        /** check to see if there are duplicate meds that have been selected */
        if (this.refList.findIndex(x => x.ndcNumber === selectedItemPref) > -1) {
            this.strErr = 'Error: This medication has already been specified for this PO';
            return;
        }
        else {
            this.selectedItemFamily = this.records.find(x => x.origNdcNumber === selectedItemPref);
            this.createRefHistItems(this.selectedItemFamily);
            this.costPerDose =
                this.calcCostPerDose(this.selectedItemFamily.unitPrice, this.selectedItemFamily.packageSize);
            this.ndcDescription = selectedVal;
            /*** set the cursor to the Quantity field and highlight the contents  ***/
            DwUtils.highlightFocus('PoQtyId');
        }
    }
    public doClearMedication(): void {
        this.clearForm();
        DwUtils.setFocus('medFamilyId');
    }
    public doQuantityChange(event: any): void  {
        this.selectedItemFamily.extended =
            (Math.round(Number(this.selectedItemFamily.quantity) * Number(this.selectedItemFamily.unitPrice) * 100) / 100);
    }
    public doAddNewMedicationItem(): void {

    }
    public costBaseChanged(): boolean {
        if (this.costBase !== this.selectedItemFamily.costBase) {
            return true;
        }
        return false;
    }
    public keyPropertiesChanged(): boolean {
        if (this.costBaseChanged() === true) {
            return true;
        }
        if (this.leadTimeDays !== this.selectedItemFamily.leadTimeDays) {
            return true;
        }
        if (this.unitPrice !== this.selectedItemFamily.unitPrice) {
            return true;
        }

        return false;
    }
    public updateSupplierMedicationRecord(): void {
        const sm: SupplierMedication = new SupplierMedication();
        sm.setFromSupplierMeds(this.selectedItemFamily, this.costPerDose);

        this.medService.updateMedicationonSupplierByFK(sm).subscribe(
            (data) => {
                this.submitAddPOItemEvent.emit(this.selectedItemFamily);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Updating supplier medication');
            });
    }
    public updateCostBaseRecord(): void {

        this.medService.updateMedicationCostBase(this.selectedItemFamily.itemId, this.selectedItemFamily.costBase).subscribe(
            (data) => {
                // done
                const res = data;
            },
            (error) => {
                Settings.getInstance().handleError(error, 'updating the cost base');
            });
    }
    public onSubmitPOItem(): void {
        if (this.costBaseChanged() === true ) {
            this.updateCostBaseRecord();
        }
        if (this.keyPropertiesChanged() === true) {
            this.updateSupplierMedicationRecord();
        }
        else {
            this.submitAddPOItemEvent.emit(this.selectedItemFamily);
        }
    }
    public onCancelPOItem(): void {

        this.cancelAddPOItemEvent.emit();
    }
    public calcCostPerDose(unit: number, pkgSize: number): number {

        if (unit === 0 && pkgSize === 0)
            return 0;

        return Math.round((unit / pkgSize) * 100) / 100;
    }
}


